import Panel from './Panel.vue';

export default Panel;
